<template>
  <div class="w-100" v-if="amendBookingStore.cart.prix_total == 0">
    <v-btn @click="$emit('handle_free_checkout')" :loading="loading" color="primary-dark" block
      class="sm-fullwidth mt-4 checkout_btn" variant="tonal" size="default"> <v-icon
        icon="mdi-arrow-right-bold"></v-icon> Valider ma commande</v-btn>
  </div>
  <div class="w-100" v-else>
    <v-btn @click="$emit('access_checkout')" :loading="loading" color="primary-dark" block
      class="sm-fullwidth mt-4 checkout_btn" variant="tonal" size="default"> <v-icon
        icon="mdi-arrow-right-bold"></v-icon> Accèder au paiement</v-btn>
    <div class="d-flex justify-center mb-3 w-100">
      <div class="bg-white pa-1 rounded mt-3">
        <img class="logo_paiement" src="https://sportips.fr/images/logo_securise.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useAmendBookingStore } from "@/stores/amendBookingStore";
export default {
  computed: {
    ...mapStores(useAmendBookingStore),
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    handle_free_checkout() {
      this.loading = true;
      this.$emit('handle_free_checkout');
    },
    access_checkout() {
      this.loading = true;
      this.$emit('access_checkout');
    }
  }
};
</script>

<style lang="scss" scoped>
.logo_paiement {
  width: 150px;
  max-width: 100%;
  height: auto;
}
</style>